import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75f5ece0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings-container" }
const _hoisted_2 = { class: "settings-items-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin-block-start":"0.5em"} }, "설정은 자동으로 저장됩니다.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "세 글자 이상의 명사도 몰?루화합니다.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "몰?루 대신 아!루", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "문장에 \"몰루\"와 같이 잘 알려진 밈 단어가 발견되면 \"몰?루\"와 같이 무조건 치환됩니다.", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "\"정말 꼴받게 하네요~\"", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ignoreNounLengthLimit) = $event)),
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.ignoreNounLengthLimit]
        ]),
        _createTextVNode(" 명사 길이 제한 무시"),
        _hoisted_4,
        _hoisted_5
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.changeMolluMark) = $event)),
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.changeMolluMark]
        ]),
        _createTextVNode(" 삽입될 기호를 느낌표(!)로 변경"),
        _hoisted_6,
        _hoisted_7
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.forceMollufyForPredefinedWords) = $event)),
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.forceMollufyForPredefinedWords]
        ]),
        _createTextVNode(" 일부 단어 강제 몰?루화"),
        _hoisted_8,
        _hoisted_9
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.enableMolluImageAnimation) = $event)),
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.enableMolluImageAnimation]
        ]),
        _createTextVNode(" 몰?루 배경 일러스트 애니메이션 활성화"),
        _hoisted_10,
        _hoisted_11
      ])
    ])
  ]))
}